export default class Node3D {
  constructor(transform = null) {
    this.transform = transform;
    this.userData = null;
  }
}
